"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPersistedData = exports.isOneTrustConsentsAnalitycsChecked = void 0;
const next13_utils_secure_local_storage_1 = __importDefault(require("@gerenciatd/next13.utils.secure.local-storage"));
const secureStorageLib = new next13_utils_secure_local_storage_1.default();
const next_utils_common_1 = require("@gerenciatd/next.utils.common");
// C2 => analitica
const isOneTrustConsentsAnalitycsChecked = () => {
    const cookieValue = (0, next_utils_common_1.getCookie)('OptanonConsent');
    return cookieValue.indexOf('C0002:1') > 0;
};
exports.isOneTrustConsentsAnalitycsChecked = isOneTrustConsentsAnalitycsChecked;
function getPersistedData() {
    let geo = {};
    const persistedInfo = secureStorageLib.getItem('ts');
    // hago el check de los 6 meses
    if (persistedInfo && persistedInfo.geo) {
        geo = {
            cp: persistedInfo.geo.postalCode || '',
            zone: persistedInfo.geo.zone || '',
            municipio: persistedInfo.geo.municipio || '',
            businessZones: persistedInfo.geo.businessZones || '',
        };
    }
    else if ((0, exports.isOneTrustConsentsAnalitycsChecked)()) {
        // no tengo nada persistido y tengo que intentar llamar de nuevo al cliente para geolocalizarle
        geo = null;
    }
    else {
        // no tengo nada persistido
        geo = {
            cp: '28030',
            zone: 'ZL',
            municipio: 'Madrid',
            businessZones: [],
        };
    }
    return { geo };
}
exports.getPersistedData = getPersistedData;
exports.default = getPersistedData;
//# sourceMappingURL=index.js.map